module.exports = __webpack_public_path__ + "ec6cae2b78bd34737a76e09cfb311502.png";